import React from 'react';
import PropTypes from 'prop-types';
import DismissButton from './DismissButton';
import SaveButton from './SaveButton';

const DismissSaveButtonsPanel = (props) => {
    return(
        <div className="col-xs-12">
            <DismissButton
                onClick={props.onDismissButtonClick} />
            <SaveButton
                disabled={props.isSaveBtnDisabled}
                onClick={props.onSaveButtonClick} />
        </div>
    );
};

DismissSaveButtonsPanel.propTypes = {
    onDismissButtonClick: PropTypes.func,
    onSaveButtonClick: PropTypes.func,
    isSaveBtnDisabled: PropTypes.bool
};

export default DismissSaveButtonsPanel;


// WEBPACK FOOTER //
// ./src/components/Buttons/DismissSaveButtonsPanel.js